<template>
  <div v-loading="loading" class="GmzHqsjfxTableCl">
    <div class="_title">
      <p class="_title_info">处理行情数据分析</p>
    </div>
    <div v-if="!dataExist">
      <div style="text-align: center;margin-top: 150px;margin-bottom: 100px;color: #27660dbf;font-size: 30px;">暂无可处理的行情分析数据</div>
      <div style="    text-align: center;margin-top: 50px;">
        <el-button style="width: 200px;height: 50px;font-size: 20px;margin-bottom: 100px;" type="success"  @click="closeItem"> 关   闭 </el-button>
      </div>
    </div>
    <div v-else>
      <div style="height: 670px;">
        <div style="float: left;width: 65%;">
          <div style="font-size: 16px;font-weight: 700;">购销合同</div>
          <div style="margin-top: 20px;">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-card shadow="never">
                  <div style="display: inline-block;width: calc(100% - 150px);">
                    <div>
                      <div class="demo-image__preview" style="height: 585px;text-align: center;overflow-y:auto">
                        <el-image
                          style="width: 100%"
                          :src="getPicUrl(gxhtImgList[0])"
                          :preview-src-list="getPicUrlArr(gxhtImgList[0])"></el-image>
                      </div>
                    </div>
                  </div>
                  <div style="display: inline-block;width: 130px;padding-left: 10px;float: right;" >
                    <div class="demo-image__preview">
                      <el-image
                        class="small_img"
                        :src="getPicUrl(gxhtImgList[1])"
                        :preview-src-list="getPicUrlArr(gxhtImgList[1])"></el-image>
                      <el-image
                        class="small_img"
                        :src="getPicUrl(gxhtImgList[2])"
                        :preview-src-list="getPicUrlArr(gxhtImgList[2])"></el-image>
                      <el-image
                        class="small_img"
                        :src="getPicUrl(gxhtImgList[3])"
                        :preview-src-list="getPicUrlArr(gxhtImgList[3])"></el-image>
                      <el-image
                        class="small_img"
                        :src="getPicUrl(gxhtImgList[4])"
                        :preview-src-list="getPicUrlArr(gxhtImgList[4])"></el-image>
                      <el-image
                        class="small_img"
                        :src="getPicUrl(gxhtImgList[5])"
                        :preview-src-list="getPicUrlArr(gxhtImgList[5])"></el-image>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="float: right;width: 35%;padding-left: 20px">
          <el-descriptions title="基本信息" :column="1" border >
            <el-descriptions-item labelStyle="width:110px" >
              <template slot="label">
                购买证编号
              </template>
              {{record.xkzBh}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                化学品名称
              </template>
              {{record.hxpMc}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                购买数量
              </template>
              {{record.hzsl+'('+record.hzslDwLabel+')'}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                单价
              </template>
              {{record.dj+'('+record.djDwLabel+')'}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                核发日期
              </template>
              {{record.hfrq}}
            </el-descriptions-item>
          </el-descriptions>
          <!--      要提交的form表单-->
          <div style="font-size: 16px;font-weight: 700;margin-top: 20px;">修改信息</div>
          <div style="margin-top: 20px;">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-card shadow="never">
                  <el-form
                    :rules="rules"
                    ref="editForm"
                    label-position="right"
                    style="height:297px;padding: 20px;"
                    label-width="120px"
                  >
                    <el-form-item label="单价："
                                  prop="dj">
                      <el-input
                        ref="djInput"
                        style="width: 70%"
                        v-model="editForm.dj"
                        placeholder="请输入单价"
                        @keyup.enter.native="changeBlur('htqdRqYId')"
                      />
                      <el-select
                        style="width: 30%"
                        v-model="editForm.djDw"
                        placeholder="请选择单位"
                      >
                        <el-option
                          v-for="item in dwList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="合同签订日期：">
<!--                      <el-input v-model="editForm.htqdRq" />-->
                      <el-input class="date_input" ref="htqdRqYId" type="text" maxlength="4" v-model="editForm.htqdRqY" placeholder="4位年份" @keyup.enter.native="changeBlur('htqdRqMId')" @input = "changeBlur('htqdRqMId','change')" />-
                      <el-input class="date_input" ref="htqdRqMId" type="text" maxlength="2" v-model="editForm.htqdRqM" placeholder="2位月份"  @keyup.enter.native="changeBlur('htqdRqDId')" @input = "changeBlur('htqdRqDId','change')"/>-
                      <el-input class="date_input" ref="htqdRqDId" type="text" maxlength="2" v-model="editForm.htqdRqD" placeholder="2位日期" @keyup.enter.native="changeBlur('jhrqYId')" />
                    </el-form-item>
                    <el-form-item label="交货日期：" prop="jhrq">
<!--                      <el-input v-model="editForm.jhrq" />-->
                      <el-input class="date_input" ref="jhrqYId" type="text" maxlength="4" v-model="editForm.jhrqY" placeholder="4位年份" @keyup.enter.native="changeBlur('jhrqMId')" @input = "changeBlur('jhrqMId','change')" />-
                      <el-input class="date_input" ref="jhrqMId" type="text" maxlength="2" v-model="editForm.jhrqM" placeholder="2位月份" @keyup.enter.native="changeBlur('jhrqDId')"  @input = "changeBlur('jhrqDId','change')" />-
                      <el-input class="date_input" ref="jhrqDId" type="text" maxlength="2" v-model="editForm.jhrqD" placeholder="2位日期" />
                    </el-form-item>
                    <div class="buttonList">
                      <el-button type="primary" @click="save"> 保存 </el-button>
                      <el-button @click="closeItem"> 关闭 </el-button>
                    </div>
                  </el-form>
                </el-card>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div style="margin-top:20px;">
        <span style="font-size: 16px;font-weight: 700;">相关运输证</span>
        <div class="tablemes" style="margin-top:20px;">
          <el-table
            ref="yszTabel"
            :data="localData.yszDtos"
            border
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              prop="xkzBh"
              label="运输证编号"
            />
            <el-table-column
              prop="hxpMc"
              label="化学品"
            />
            <el-table-column
              label="核准数量"
            >
              <template slot-scope="scope">
                {{scope.row["xkzSl"] +
                "  (" +
                scope.row["xkzSlDwLabel"] +
                ")"}}
              </template>
            </el-table-column>
            <el-table-column
              prop="fhdwMc"
              label="发货单位"
            />
            <el-table-column
              prop="shdwMc"
              label="收货单位"
            />
            <el-table-column
              prop="ysdwMc"
              label="运输单位"
            />
            <el-table-column
              prop="hfrq"
              label="核发时间"
            />
            <el-table-column label="操作" align="center" width="200px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.zt != '00'"
                  v-preventReClick
                  type="primary"
                  icon="el-icon-document"
                  size="mini"
                  @click="getYszGxht(scope.$index, scope.row)"
                >查看合同</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <el-dialog :title="'运输证'+yszBh+'的购销合同'" :visible.sync="updFlag" >
      <div class="demo-image__preview" style="display: inline-block;" v-for="yszurl in yszGxhtData.wjdzList" >
        <el-image
          style="width: 100%; height: auto"
          :src="getPicUrl(yszurl)"
          :preview-src-list="getPicUrlArr(yszurl)"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getTableDczDeatil, editDealSaveTableData, editHisSaveTableData} from '@/assets/js/gmzHqsjfx'
  import {returnShowPic} from "@/assets/js/common";
  import {gmzGxhtxxData, yszGxhtxxData} from "@/assets/js/system";
  import {isEmpty} from "@/utils/tool";
export default {
  name: 'GmzHqsjfxTableCl',
  props: ['dataId','editFlag'],
  data() {
    return {
      rules: {
        dj: [{trigger: 'change',validator: (rule, value, callback) => {
          if(!/^[1-9]\d{0,6}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(this.editForm.dj)){
            return callback('整数位最大长度7位,保留2位小数');
          }
            callback();
          }, }],
      },
      yszBh: '',
      updFlag:false, //运输证购销合同
      dataExist: true,
      loading: false,
      record: {},
      gxhtImgList:['none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg'], //默认六张图片
      localData:{},
      yszGxhtData: '',
      dwList: [
        {
          value: '1',
          label: '元',
        },
        {
          value: '2',
          label: '欧元',
        },
        {
          value: '3',
          label: '美元',
        },
        {
          value: '4',
          label: '英镑',
        },
        {
          value: '5',
          label: '日元',
        },
        {
          value: '6',
          label: '港元',
        },
      ],
      editForm:{
        id:'',
        dj:'',
        djDw:'',
        htqdRq:'',
        jhrq:'',
        //处理日期的
        htqdRqY:'',
        htqdRqM:'',
        htqdRqD:'',
        jhrqY:'',
        jhrqM:'',
        jhrqD:'',
      }
    }
  },
  mounted(){
    if(this.editFlag){ //编辑
      if(!isEmpty(this.dataId)){
        this.addLoadData(this.dataId)
      }else{
        this.dataExist = false
      }
    }else{
      this.addLoadData()
    }
  },
  methods: {
    changeBlur(refVal,type){ //修改元素获取的焦点
      if(type == "change"){
        if(refVal == 'htqdRqMId' && this.editForm.htqdRqY.length != 4){
          return
        }
        if(refVal == 'htqdRqDId' && this.editForm.htqdRqM.length !=2){
          return
        }
        if(refVal == 'jhrqMId' && this.editForm.jhrqY.length != 4){
          return
        }
        if(refVal == 'jhrqDId' && this.editForm.jhrqM.length != 2){
          return
        }
      }
      this.$nextTick(() => {
        this.$refs[refVal].focus()
      })
    },
    cshYwsj(){ //数据初始化
      this.editForm=this.$options.data().editForm
      this.gxhtImgList = ['none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg','none_data.jpg'] //默认六张图片
      this.localData = {}
      this.record = {}
    },
    addLoadData(id){
      getTableDczDeatil(isEmpty(id)?'':id).then((e)=>{
        this.cshYwsj()
        if(e.data.data){
          this.record = {...e.data.data}
          this.editForm.id = e.data.data.id
          this.editForm.dj = e.data.data.dj
          this.editForm.djDw = e.data.data.djDw
          //处理年月日
          if(!isEmpty(this.record.htqdRq)){
            this.editForm.htqdRq = this.record.htqdRq;
            this.editForm.htqdRqY = this.record.htqdRq.split("-")[0]
            this.editForm.htqdRqM = this.record.htqdRq.split("-")[1]
            this.editForm.htqdRqD = this.record.htqdRq.split("-")[2]
          }
          if(!isEmpty(this.record.jhrq)){
            this.editForm.jhrq = this.record.jhrq;
            this.editForm.jhrqY = this.record.jhrq.split("-")[0]
            this.editForm.jhrqM = this.record.jhrq.split("-")[1]
            this.editForm.jhrqD = this.record.jhrq.split("-")[2]
          }
          gmzGxhtxxData(e.data.data.xkzBh)
            .then((e) => {
              this.localData = e.data.data
              if(this.localData.wjdzList != null && this.localData.wjdzList.length >  0){
                for(let i = 0;i<this.localData.wjdzList.length;i++){
                  this.gxhtImgList[i] = this.localData.wjdzList[i]
                }
              }
            })
            .catch(() => {
              this.loading = false
            })
          this.$nextTick(() => {
            this.$refs['htqdRqYId'].focus()
          })
        }else{
          this.dataExist = false
        }
      })
    },
    save(){
      if(this.editFlag){
        this.editHistSave()
      }else{
        this.editDealSave()
      }
    },
    editDealSave(){ //初始处置，自动获取下一个
      this.loading = true
      if(isEmpty(this.editForm.htqdRqY) && isEmpty(this.editForm.htqdRqM) && isEmpty(this.editForm.htqdRqD)){
        this.editForm.htqdRq = ''
      }else if(!isEmpty(this.editForm.htqdRqY) || !isEmpty(this.editForm.htqdRqM)|| !isEmpty(this.editForm.htqdRqD)){
        this.editForm.htqdRq = this.editForm.htqdRqY+'-'+this.editForm.htqdRqM+'-'+this.editForm.htqdRqD
      }
      if(isEmpty(this.editForm.jhrqY) && isEmpty(this.editForm.jhrqM) && isEmpty(this.editForm.jhrqD)){
        this.editForm.jhrq = ''
      }else if(!isEmpty(this.editForm.jhrqY) || !isEmpty(this.editForm.jhrqM)|| !isEmpty(this.editForm.jhrqD)){
        this.editForm.jhrq = this.editForm.jhrqY+'-'+this.editForm.jhrqM+'-'+this.editForm.jhrqD
      }
      editDealSaveTableData(this.editForm).then((e) => {
        this.$message.success("保存成功，请继续处理下一条数据")
        this.addLoadData()
        this.loading = false
      }).catch((e)=>{
        this.loading = false
      })
    },
    editHistSave(){ //编辑保存，只编辑本条数据
      this.loading = true
      if(isEmpty(this.editForm.htqdRqY) && isEmpty(this.editForm.htqdRqM) && isEmpty(this.editForm.htqdRqD)){
        this.editForm.htqdRq = ''
      }else if(!isEmpty(this.editForm.htqdRqY) || !isEmpty(this.editForm.htqdRqM)|| !isEmpty(this.editForm.htqdRqD)){
        this.editForm.htqdRq = this.editForm.htqdRqY+'-'+this.editForm.htqdRqM+'-'+this.editForm.htqdRqD
      }
      if(isEmpty(this.editForm.jhrqY) && isEmpty(this.editForm.jhrqM) && isEmpty(this.editForm.jhrqD)){
        this.editForm.jhrq = ''
      }else if(!isEmpty(this.editForm.jhrqY) || !isEmpty(this.editForm.jhrqM)|| !isEmpty(this.editForm.jhrqD)){
        this.editForm.jhrq = this.editForm.jhrqY+'-'+this.editForm.jhrqM+'-'+this.editForm.jhrqD
      }
      editHisSaveTableData(this.editForm).then((e) => {
        this.$message.success("编辑成功")
        this.closeItem()
        this.loading = false
      }).catch((e)=>{
        this.loading = false
      })
    },
    closeItem() {
      this.$parent.showClPup = false
      this.$parent.editFlag = false
      this.$parent.loadDatasource()
    },
    getPicUrl(picUrl){
      if(picUrl == 'none_data.jpg'){
        return require('@/assets/img/none_data.jpg')
      }else{
        return returnShowPic()+picUrl
      }
    },
    getPicUrlArr(picUrl){
      let picArr = []
      if(picUrl == 'none_data.jpg'){
        picArr.push(require('@/assets/img/none_data.jpg'))
      }else{
        picArr.push(returnShowPic()+picUrl)
      }
      return picArr
    },
    getYszGxht(index,ysz){
      this.yszBh = ysz.xkzBh
      this.yszGxhtData = ''
      yszGxhtxxData(ysz.xkzId)
        .then((e) => {
          this.yszGxhtData = e.data.data
          if(this.yszGxhtData != null && e.data.data.wjdzList != null && e.data.data.wjdzList.length > 0){
            this.updFlag = true
          }else{
            this.$message.warning('该运输证没有购销合同!')
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang='less' scoped>
.GmzHqsjfxTableCl {
  overflow-y: auto;
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 20px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 15px;
      height: 15px;
      font-family: Helvetica;
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 40px auto 0px auto;
    width: 50%;
  }

  .small_img{
    width: 114px;
    height: 114px;
  }

  .date_input{
    width: 31%;
  }

  /deep/ .el-dialog .el-dialog__body {
    height: 650px !important;
    overflow-y: auto !important;
  }
}
</style>
